var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","overflow":"hidden","max-width":"600px"},style:({position: _vm.device === 'pc' ? 'relative' : '', margin: _vm.device === 'pc' ? '0 auto' : ''})},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }